import React from 'react';
import { FaPrint, FaTrash } from 'react-icons/fa';
import { ActionsContainer, ActionButton } from './styles';

const PrintActions = ({
  canPrint,
  isPrinting,
  htmlContent,
  onPrint,
  onClear,
}) => {
  return (
    <ActionsContainer>
      <div className="button-group">
        {htmlContent && (
          <ActionButton
            variant="outlined"
            onClick={onClear}
            disabled={isPrinting}
          >
            <FaTrash />
            Limpar Preview
          </ActionButton>
        )}
        <ActionButton
          onClick={onPrint}
          disabled={!canPrint}
          isLoading={isPrinting}
          style={{
            backgroundColor: canPrint ? '#2EC9B7' : undefined,
          }}
        >
          <FaPrint />
          {isPrinting ? 'Imprimindo...' : 'Imprimir'}
        </ActionButton>
      </div>
    </ActionsContainer>
  );
};

export default PrintActions;
